import React from 'react';
import { createContext, useContext } from 'react';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// import _ from 'lodash';

// import { axios } from '../../../../utils/axios';
// import { success, successAPI, errorAPI, getMaxPageSize, isNumeric } from '../../../../utils/utils';
import Yup from '../../../../utils/yup';
// import {  } from '../../../../utils/enums';


export const fields = {
  remarks: {
    id: 'remarks',
    label: 'Remarks',
    placeholder: 'Enter remarks',
    rows: 5,
  },
};


export const formSchema = (id: number|null= null) => {
  return Yup.object().shape({
    remarks: Yup.string().required().label(fields.remarks.label),
  })
}


let formikContext: any = null;
export const FormikContext = createContext<any>(null);
export const useFormikContext = () => {
    formikContext = useContext(FormikContext);
    if (!formikContext) {
      throw new Error('useFormikContext must be used within a FormikProvider');
    }
    return formikContext;
};


export interface initialValuesStruct {
  remarks: string,
};
export const initialValues: initialValuesStruct = {
  remarks: '',
};


interface InitState {
  isLoading: boolean,
  show: boolean,
  details: any,
}


function NewReducer() {
  const name = 'jobFormDeleteSlice';


  const initialState: InitState = {
    isLoading: false,
    show: false,
    details: initialValues,
  };


  const reducers = {
    resetSlice: () => {
      return initialState;
    },
    setLoading: (state: InitState, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setValues: (state: InitState, action: PayloadAction<any>) => {
      state.details = action.payload;
    },
    

    setShow: (state: InitState, action: PayloadAction<{ show: boolean }>) => {
      state.isLoading = false;
      state.show = action.payload.show;
    },
  };


  const apis = {
    
  };


  const { reducer, actions } = createSlice({
    name,
    initialState,
    reducers,
  });


  return {
    reducer,
    ...actions,
    ...apis,
  };
}


export default NewReducer();